export { default } from './CopyButtonCDS';
